$(document).ready(function() {
  $('.read-more-j').click(function(e) {
    e.preventDefault();
    $('.read-more-content-j').slideDown(200); // Set the duration to 200 milliseconds
    $(this).hide();
    $('.read-less-j').show();
  });

  $('.read-less-j').click(function(e) {
    e.preventDefault();
    $('.read-more-content-j').slideUp(200); // Set the duration to 200 milliseconds
    $(this).hide();
    $('.read-more-j').show();
  });
});
